/**
 * Copyright (c) 2010-2026 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import { catchError, concatMap, mergeMap, Observable, of, take } from 'rxjs';
import { BeginTokenRefresh, TokenRefreshSuccessful } from '../state/auth.actions';

@Injectable({ providedIn: 'root' })
export class CheckTokenInterceptor implements HttpInterceptor {

    constructor(private store: Store, private actions$: Actions) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const clone = request.clone();
        const refreshToken$ = () => {
            return this.store.dispatch(new BeginTokenRefresh()).pipe(
                concatMap(() => this.actions$),
                ofActionSuccessful(TokenRefreshSuccessful),
                take(1),
                concatMap(() => next.handle(clone))
            );
        };
        return next.handle(request).pipe(
            mergeMap((evt) => {
                return of<HttpEvent<any>>(evt).pipe(
                    catchError((err, caught) => {
                        if (err.status === 401) {
                            return refreshToken$();
                        }
                        return caught;
                    })
                );
            }),
        );
    }
}
